import { Switch } from "@/components/ui/switch";
import { Panel } from "@/components/admin/Field";

const SECTIONS = [
  { key: "countdown", label: "Contagem decrescente", hint: "Temporizador no topo da página até à abertura." },
  { key: "player_history", label: "Histórico de jogadores", hint: "Gráfico das últimas 24 horas." },
  { key: "gallery", label: "Galeria", hint: "Imagens da cidade em marquee." },
  { key: "news", label: "Notícias", hint: "Últimas publicações do Discord." },
  { key: "store", label: "Loja", hint: "Destaque dos pacotes Tebex." },
  { key: "community", label: "Comunidade / Discord", hint: "Widget do Discord e convite." },
];

export function SectionsEditor({ sections = {}, update }) {
  return (
    <Panel title="Secções da página inicial" description="Liga ou desliga cada secção. A Equipa tem o seu interruptor em Informações.">
      <div className="divide-y divide-eden-border rounded-md border border-eden-border bg-eden-bg" data-testid="sections-editor">
        {SECTIONS.map((s) => {
          const on = sections[s.key] !== false;
          return (
            <div key={s.key} className="flex items-center justify-between gap-4 p-4" data-testid={`section-row-${s.key}`}>
              <div>
                <p className="text-sm font-medium text-eden-text">{s.label}</p>
                <p className="text-xs text-eden-muted">{on ? s.hint : "Escondida no site público."}</p>
              </div>
              <Switch checked={on} onCheckedChange={(v) => update("sections", { [s.key]: v })} aria-label={`Mostrar ${s.label}`} data-testid={`section-switch-${s.key}`} />
            </div>
          );
        })}
      </div>
    </Panel>
  );
}
